import { PricingData } from '../types/PricingCalculator';

export const pricingData: PricingData = {
    "all_in_one_devices": [
        {
            "name": "Barway Android Handheld POS",
            "description": "Affordable Android handheld POS with built-in 58mm thermal printer, 5.5\" touchscreen, supports 3G/WiFi connectivity.",
            "description_fr": "POS portable Android abordable avec imprimante thermique 58mm intégrée, écran tactile 5,5\", supporte 3G/WiFi.",
            "description_rw": "POS ya Android ihendutse ifite printeri ya 58mm, ecran ya 5.5\" na 3G/WiFi.",
            "price": 120,
            "currency": "USD",
            "availability": "Imported",
            "link": "https://barway.en.made-in-china.com/product/YmepwijKnxWv/China-Barway-Handheld-Android-POS-System-Terminal-with-Touch-Screen-3G-WiFi-Built-in-Printer.html",
            "image": "https://placehold.co/300x200/4F46E5/FFFFFF?text=Barway+POS"
        },
        {
            "name": "Generic Android 6.0 POS Terminal",
            "description": "Handheld POS with Android 6.0, built-in 58mm receipt printer, 3G/WiFi/Bluetooth, 5000mAh battery.",
            "description_fr": "POS portable Android 6.0 avec imprimante 58mm intégrée, 3G/WiFi/Bluetooth, batterie 5000mAh.",
            "description_rw": "POS ya Android 6.0 ifite printeri 58mm, 3G/WiFi/Bluetooth, bateri 5000mAh.",
            "price": 185,
            "currency": "USD",
            "availability": "Rwanda",
            "link": "https://rwandadeals.rw/product/pos-terminalall-in-one-handheld-pda-printer-smart-pos-terminal-wireless-portable-printers-intelligent-payment-terminal-function-btwifiusb-otg-3g-communication",
            "image": "https://placehold.co/300x200/059669/FFFFFF?text=Generic+POS"
        },
        {
            "name": "Sunmi V2s Smart POS",
            "description": "Rugged all-in-one Android 11 POS with 5.5\" HD screen, 2GB RAM/16GB ROM, 4G/WiFi/Bluetooth, integrated 58mm printer and 2D scanner.",
            "description_fr": "POS Android 11 tout-en-un robuste, écran 5,5\" HD, 2GB/16GB, 4G/WiFi/Bluetooth, imprimante 58mm et scanner 2D intégrés.",
            "description_rw": "POS ikomeye ya Android 11, ecran 5.5\" HD, 2GB/16GB, 4G/WiFi/Bluetooth, ifite printeri 58mm na scanner 2D.",
            "price": 300,
            "currency": "USD",
            "availability": "Imported",
            "link": "https://www.concept.biz/en/p/sunmi-v2s",
            "image": "https://placehold.co/300x200/DC2626/FFFFFF?text=Sunmi+V2s"
        }
    ],
    "phone_and_printer_solution": {
        "smartphones": [
            {
                "name": "Infinix Smart 5 (4G)",
                "description": "Budget Android smartphone, 2GB RAM, 32GB storage, 5000mAh battery.",
                "description_fr": "Smartphone Android économique, 2GB RAM, 32GB stockage, batterie 5000mAh.",
                "description_rw": "Telefoni ya Android ihendutse, 2GB RAM, 32GB ububiko, bateri 5000mAh.",
                "price": 107800,
                "currency": "RWF",
                "availability": "Rwanda",
                "link": "https://rootsrwanda.rw/product-list/MQ==/NjM=/Mobiles-&-Tablets/OTHER-BRANDS",
                "image": "https://placehold.co/300x200/7C3AED/FFFFFF?text=Infinix+Smart+5"
            },
            {
                "name": "Samsung Galaxy A03",
                "description": "Entry-level Samsung phone, 2GB RAM, 32GB storage, 5000mAh battery.",
                "description_fr": "Téléphone Samsung d'entrée de gamme, 2GB RAM, 32GB stockage, batterie 5000mAh.",
                "description_rw": "Telefoni ya Samsung y’icyiciro cy’itangiriro, 2GB RAM, 32GB ububiko, bateri 5000mAh.",
                "price": 126000,
                "currency": "RWF",
                "availability": "Rwanda",
                "link": "https://kanis.rw/product/samsung-galaxy-a03-32gb-mobile",
                "image": "https://placehold.co/300x200/1E40AF/FFFFFF?text=Samsung+Galaxy+A03"
            },
            {
                "name": "Infinix Hot 10 Play",
                "description": "Mid-range budget phone, 4GB RAM, 64GB storage, large display, 6000mAh battery.",
                "description_fr": "Téléphone milieu de gamme abordable, 4GB RAM, 64GB stockage, écran large, batterie 6000mAh.",
                "description_rw": "Telefoni iri hagati mu rwego, 4GB RAM, 64GB ububiko, ecran nini, bateri 6000mAh.",
                "price": 178000,
                "currency": "RWF",
                "availability": "Rwanda",
                "link": "https://rootsrwanda.rw/product-list/MQ==/NjM=/Mobiles-&-Tablets/OTHER-BRANDS",
                "image": "https://placehold.co/300x200/EA580C/FFFFFF?text=Infinix+Hot+10"
            }
        ],
        "printers": [
            {
                "name": "58mm Bluetooth Thermal Printer",
                "description": "Portable receipt printer (58mm paper width) with Bluetooth and USB connectivity.",
                "description_fr": "Imprimante thermique portable (58mm) avec Bluetooth et USB.",
                "description_rw": "Printeri y’ikemezo ya 58mm ifite Bluetooth na USB.",
                "price": 52000,
                "currency": "RWF",
                "availability": "Rwanda",
                "link": "https://cagura.rw/product/view/239/bluetooth_usb_thermal_receipt_printer_58mm_pos_printer",
                "image": "https://placehold.co/300x200/0891B2/FFFFFF?text=Bluetooth+Printer"
            },
            {
                "name": "X-POS P500 Mobile Printer",
                "description": "Compact battery-powered receipt printer, supports 2D barcode printing, fast thermal printing.",
                "description_fr": "Imprimante de reçus compacte sur batterie, supporte l'impression de codes-barres 2D.",
                "description_rw": "Printeri nto ikoresha bateri, isohora impapuro vuba kandi ishyigikira 2D.",
                "price": 99,
                "currency": "USD",
                "availability": "Rwanda",
                "link": "https://shopit.rw/pos-printers/",
                "image": "https://placehold.co/300x200/BE185D/FFFFFF?text=X-POS+P500"
            },
            {
                "name": "X-POS P810 Receipt Printer",
                "description": "Portable 58/80mm thermal printer with adjustable paper width, 90mm/s print speed, 203dpi resolution.",
                "description_fr": "Imprimante thermique portable 58/80mm, largeur ajustable, 90mm/s, résolution 203dpi.",
                "description_rw": "Printeri ya 58/80mm, umuvuduko 90mm/s, irema neza 203dpi.",
                "price": 139,
                "currency": "USD",
                "availability": "Rwanda",
                "link": "https://shopit.rw/pos-printers/",
                "image": "https://placehold.co/300x200/7C2D12/FFFFFF?text=X-POS+P810"
            }
        ],
        "notes": "For a complete POS, combine one smartphone (as the screen) with one printer for receipts. If the user already has a smartphone, they can simply select a printer from the list. Ensure the phone supports the printer's connection (Bluetooth is recommended for ease). No payment terminal is needed as this setup is for recording transactions only.",
        "notes_fr": "Pour un POS complet, combinez un smartphone (comme écran) avec une imprimante pour les reçus...",
        "notes_rw": "Ku POS yuzuye, huza telefoni (nk’ecran) n’imprimeri yo gusohora impapuro..."
    },
    "optional_accessories": {
        "barcode_scanners": [
            {
                "name": "X-POS LX6300 2D Scanner",
                "description": "Wired 2D barcode scanner (USB interface), capable of scanning from screens.",
                "description_fr": "Scanner 2D filaire (USB), ushobora no gusoma kuri ecran.",
                "description_rw": "Iskaneri 2D ikoreshwa n’umugozi (USB), ishobora gusoma kuri ecran.",
                "price": 97,
                "currency": "USD",
                "availability": "Rwanda",
                "link": "https://shopit.rw/pos-equipment/barcode-scanners/",
                "image": "https://placehold.co/300x200/0D9488/FFFFFF?text=X-POS+Scanner"
            },
            {
                "name": "Inateck BCST-35 Bluetooth Scanner",
                "description": "Wireless 1D/2D Bluetooth barcode scanner with stand, 300,000-pixel CMOS for fast decoding.",
                "description_fr": "Scanner Bluetooth 1D/2D sans fil avec support, CMOS 300 000 pixels.",
                "description_rw": "Iskaneri ya Bluetooth 1D/2D idakoresha umugozi, ifite stand, CMOS 300,000 pixels.",
                "price": 40,
                "currency": "USD",
                "availability": "Imported",
                "link": "https://www.inateckoffice.com/products/2d-bluetooth-barcode-scanner-with-app-sdk-support-adjustable-stand-bcst-35",
                "image": "https://placehold.co/300x200/9333EA/FFFFFF?text=Inateck+Scanner"
            },
            {
                "name": "Zebra DS2278 Cordless Scanner",
                "description": "Professional-grade cordless 1D/2D scanner (DS2200 series) with cradle, high reliability.",
                "description_fr": "Scanner 1D/2D sans fil de qualité pro (série DS2200) avec base.",
                "description_rw": "Iskaneri 1D/2D y’umwuga idakoresha umugozi (DS2200) ifite base.",
                "price": 250,
                "currency": "USD",
                "availability": "Imported",
                "link": "https://www.zebra.com/us/en/products/scanners/general-purpose-handheld-scanners/ds2200-series.html",
                "image": "https://placehold.co/300x200/CA8A04/FFFFFF?text=Zebra+Scanner"
            }
        ],
        "notes": "If using a wired scanner (USB), ensure your phone supports OTG and use the correct adapter (e.g., micro-USB to USB or USB-C to USB) to connect it. Wireless Bluetooth scanners are recommended for compatibility with any smartphone (no cable needed). Choose 2D scanners if you need to scan QR codes; 1D scanners suffice for barcodes. Match any scanner's interface (Bluetooth, USB Type-C, etc.) with your device or include necessary adapters.",
        "notes_fr": "Si vous utilisez un scanner filaire (USB), assurez-vous que votre téléphone prend en charge l’OTG et utilisez l’adaptateur approprié...",
        "notes_rw": "Niba ukoresha iskaneri ikoreshwa n’umugozi (USB), reba ko telefoni ishyigikira OTG kandi ukoreshe adapiteri iboneye..."
    }
};

// Software pricing
export const softwarePricing = {
    basePrice: { value: 25, currency: "USD" as const },
    name: "HovaStore POS Software",
    description: "Complete POS management software with inventory, sales, and reporting features",
    capRWF: 585000
};

// Exchange rates
export const exchangeRates = {
    USD: 1,
    RWF: 1500
};

// User pricing constants
export const userPricing = {
    freeUsers: 2,
    additionalUserPrice: 5000, // RWF per additional user
    currency: "RWF" as const
};
